/* eslint-disable*/
import React from "react";
import { useEffect } from "react";
import { apis } from "../../services/Api";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, Link } from "react-router-dom";
import CarouselBlock from "../../common/slider/slider";
import { t } from "i18next";
import Loader from "../../common/Loader/Loader";

const MyLearning = ({ props }) => {
    const fromHomePage = true;
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [loDetails, setLoDetails] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [flag, setFlag] = useState(false);

    let getEnrollment = async () => { 
        let result = await apis.getEnrollments();
        const enrollmentData = result.data || [];
        getLoContents(enrollmentData);
    };

    function isWithin60Days(completionDeadline) {
        const [year, month, day] = completionDeadline.split("T")[0].split("-").map(Number);

        const deadlineDate = new Date(year, month - 1, day);

        const today = new Date();
        const todayDateOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());

        const in60Days = new Date(todayDateOnly);
        in60Days.setDate(todayDateOnly.getDate() + 60);
        console.log(
            "deadlineDate",
            deadlineDate,
            "todayDateOnly",
            todayDateOnly,
            "in60Days",
            in60Days,
            "compare",
            deadlineDate >= todayDateOnly,
            deadlineDate <= in60Days
        );

        return deadlineDate >= todayDateOnly && deadlineDate <= in60Days;
    }

    function sortByDateEnrolled(data, included) {
        const enrollmentMap = new Map();

        included.forEach((item) => {
            if (item.type === "learningObjectInstanceEnrollment") {
                const loId = item.relationships?.learningObject?.data?.id;
                const dateEnrolled = item.attributes?.dateEnrolled;
                if (loId && dateEnrolled) {
                    enrollmentMap.set(loId, dateEnrolled);
                }
            }
        });

        // Sort data array by dateEnrolled descending (most recently enrolled first)
        return [...data].sort((a, b) => {
            const dateA = new Date(enrollmentMap.get(a.id) || 0);
            const dateB = new Date(enrollmentMap.get(b.id) || 0);
            return dateB - dateA; // descending
        });
    }
    let myLearningIncluded = [];
    let filteredMyLearning = [];
    async function fetchMyLearning() {
        let next = true;
        let cursor = "";
        let dueCoursesArr = [];
        let enrolledCourseWithoutDueDate = [];
        let myLearningCourses = [];
        let sortEnrolledData = [];
        setIsLoading(true);
        while (next) {
            console.log("next", next);

            let myLearningData = [];
            let response = await apis.getMyLearningByDueDate(cursor, "dueDate");

            if (response) {
                if (response.data?.length > 0) {
                    for (const data of response.data) {
                        myLearningData.push(data);
                    }
                    let filterDnsData = myLearningData.filter((e, i) => {
                        return (
                            e?.attributes?.localizedMetadata &&
                            !e?.attributes?.localizedMetadata[0]?.name.includes("DNS") &&
                            !e?.attributes?.tags?.some((tag) => tag.includes("DNS"))
                        );
                    });

                    filterDnsData.forEach((ele, i) => {
                        let completionDeadline;
                        const enrollmentId = ele?.relationships?.enrollment?.data?.id;
                        const enrolledData = response?.included?.find(
                            (e) =>
                                e.id === enrollmentId &&
                                e.type === "learningObjectInstanceEnrollment"
                        );

                        const enrollCourseInstanceData = response?.included?.find(
                            (e) =>
                                e.id === enrollmentId.substring(0, enrollmentId.lastIndexOf("_")) &&
                                e.type === "learningObjectInstance"
                        );

                        if (
                            enrolledData?.attributes?.completionDeadline &&
                            new Date(enrolledData?.attributes?.completionDeadline)
                                .toString()
                                .toLowerCase() !== "invalid date"
                        ) {
                            completionDeadline = enrolledData?.attributes?.completionDeadline;
                        } else if (
                            enrollCourseInstanceData?.attributes?.completionDeadline &&
                            new Date(enrollCourseInstanceData?.attributes?.completionDeadline)
                                .toString()
                                .toLowerCase() !== "invalid date"
                        ) {
                            completionDeadline =
                                enrollCourseInstanceData?.attributes?.completionDeadline;
                        }

                        if (!completionDeadline) {
                            enrolledCourseWithoutDueDate.push(ele);
                        } else if (
                            completionDeadline !== "" &&
                            isWithin60Days(completionDeadline)
                        ) {
                            dueCoursesArr.push(ele);
                        }
                    });
                    if (response?.included?.length > 0) {
                        for (const included of response.included) {
                            myLearningIncluded.push(included);
                        }
                    }
                    if (dueCoursesArr.length >= 20) {
                        next = false;
                        break;
                    }
                }
            }
            if (response?.links?.next) {
                const urlParams = new URLSearchParams(response.links.next);
                cursor = urlParams.get("page[cursor]");
                console.log("cursor", cursor);
            } else {
                next = false;
            }
        }

        if (dueCoursesArr.length < 20 && enrolledCourseWithoutDueDate.length > 0) {
            sortEnrolledData = sortByDateEnrolled(enrolledCourseWithoutDueDate, myLearningIncluded);
            let remainingSize = 20 - dueCoursesArr.length;
            sortEnrolledData = sortEnrolledData.slice(0, remainingSize);
        }
        myLearningCourses = [...dueCoursesArr, ...sortEnrolledData];
        console.log("myLearningCourses", myLearningCourses);
        return myLearningCourses;
    }

    async function getLoContents(enrollmentData) {
        let dueCourses = await fetchMyLearning();
        //Keep it for now
        console.log("dueCourses after process", dueCourses);

        const data = [...dueCourses];
        const included = myLearningIncluded;
        myLearningIncluded = [];
        filteredMyLearning = [];
        let loContent = [];
        for (let i = 0; i < data.length; i++) {
            const enrollmentId = data[i]?.relationships?.enrollment?.data?.id;
            let completionDeadline = "";
            let enrolledData = included?.find(
                (e) => e.id === enrollmentId && e.type === "learningObjectInstanceEnrollment"
            );

            let enrollCourseInstanceData = included?.find(
                (e) =>
                    e.id === enrollmentId.substring(0, enrollmentId.lastIndexOf("_")) &&
                    e.type === "learningObjectInstance"
            );

            if (
                enrolledData?.attributes?.completionDeadline &&
                new Date(enrolledData?.attributes?.completionDeadline).toString().toLowerCase() !==
                    "invalid date"
            ) {
                completionDeadline = enrolledData?.attributes?.completionDeadline;
            } else if (
                enrollCourseInstanceData?.attributes?.completionDeadline &&
                new Date(enrollCourseInstanceData?.attributes?.completionDeadline)
                    .toString()
                    .toLowerCase() !== "invalid date"
            ) {
                completionDeadline = enrollCourseInstanceData?.attributes?.completionDeadline;
            }
            /*if(data[i]?.attributes?.loType === "certification"){
        completionDeadline = enrolledData?.attributes?.completionDeadline
      }else{
        completionDeadline = enrollCourseInstanceData?.attributes?.completionDeadline
      }*/
            const isExist = enrollmentData?.find((el) => {
                return data[i]?.id === el?.relationships?.learningObject?.data?.id;
            });
            loContent.push({
                id: data[i].id,
                imageUrl: data[i]?.attributes?.imageUrl,
                loFormat: data[i]?.attributes?.loFormat,
                name: data[i]?.attributes?.localizedMetadata[0]?.name,
                description: data[i]?.attributes?.localizedMetadata[0]?.description,
                overview: data[i]?.attributes?.localizedMetadata[0]?.overview,
                loType: data[i]?.attributes?.loType,
                Author: "",
                duration: data[i]?.attributes?.duration,
                averageRating: data[i]?.attributes?.rating?.averageRating,
                ratingsCount: data[i]?.attributes?.rating?.ratingsCount || 0,
                price: data[i].attributes?.purchasedPrice,
                enrollmentNum: data[i]?.relationships?.enrollment,
                enrollmentType: data[i]?.attributes?.imageUrl,
                instancesId: enrollCourseInstanceData.id,
                skills: data[i]?.relationships?.skills?.data[0]?.id?.split("_")[1],
                isBookmarked: data[i]?.attributes?.isBookmarked || false,
                enrollmentId: enrollmentId,
                progressPercent: isExist ? isExist?.attributes?.progressPercent : 0,
                enrollment: Object.prototype.hasOwnProperty.call(
                    data[i]?.relationships,
                    "enrollment"
                )
                    ? true
                    : false,
                // dueDate:enrollmentData?.attributes?.completionDeadline
                dueDate: completionDeadline,
                tags: data[i]?.attributes?.tags || [],
                state: enrolledData?.attributes?.state
            });
        }
        myLearningIncluded = [];
        filteredMyLearning = [];
        setLoDetails(loContent);
        setIsLoading(false);
    }

    let loDetailFilterData = loDetails.filter((data) => {
        return data?.progressPercent !== 100;
    });
    useEffect(() => {
        getEnrollment();
    }, []);

    useEffect(() => {
        setFlag(true);
    }, []);
    const playCourse = (cid, mid) => {
        navigate(`/course-player/${cid}`, {
            state: { cid, mid, goBackUrl: location?.pathname }
        });
    };
    return (
        <div className="p-0">
            <div className="Carousel-block row my-4 mb-0 mx-0">
                <div className="title-block px-0" style={{ padding: 0 }}>
                    <span className="main-head"> {t("My Learning")} </span>
                    <button
                        style={{ marginBottom: "6px" }}
                        className="btn btn-link btn-view"
                        onClick={() => {
                            navigate("/mylearning");
                        }}>
                        View All
                    </button>
                </div>
            </div>
            <div className="Carousel-block row mb-0 mx-0 px-5">
                {isLoading ? (
                    // Show loading spinner or some loading indicator
                    <div style={{ position: "relative" }}>
                        <Loader></Loader>
                    </div>
                ) : loDetails.length > 0 ? (
                    // Display data when available
                    <CarouselBlock
                        skills={props.skills}
                        myLearningObj={loDetailFilterData}
                        playCourse={playCourse}
                        componentName="MyLearning"
                        fromHomePage={fromHomePage}
                        fromUpcommingOverdue={true}
                    />
                ) : (
                    // Show "No Data" message if no data available

                    flag && (
                        <h1 className="No-data-message no-data">
                            No Courses/Learning Paths are assigned to you. Please go to{" "}
                            <Link to="/allcourses"> All Courses</Link> to explore available content.
                        </h1>
                    )
                )}
            </div>
        </div>
    );
};

export default MyLearning;
